export default __webpack_public_path__ + "static/media/ConductionTableImg.37c1d3c6.jpg";